import { createConfirmation } from 'react-confirm';
import AlertDialog from '../components/AlertDialog';
import ConfirmDialog from '../components/ConfirmDialog';
import NotificationSnackbar from '../components/NotificationSnackbar';

// See https://www.npmjs.com/package/react-confirm for more

// create confirm function
const notify = createConfirmation(NotificationSnackbar);
const confirm = createConfirmation(ConfirmDialog);
const alert = createConfirmation(AlertDialog);

// allow autocomplete for confirmDialog function
function confirmDialog (message, okText = "Confirm", cancelText = "Cancel") {
  return confirm({ message, okText, cancelText });
}

// allow autocomplete for confirmDialog function
function alertDialog (message, okText, title) {
  return alert({ message, okText, title });
}

// allow autocomplete for confirmDialog function
function notifyBar(message) {
  return notify({ message });
}

export { alertDialog, confirmDialog, notifyBar};



// WEBPACK FOOTER //
// ./src/util/dialogs.js